(() => {
  const menu = document.querySelector('[data-mobile-menu]');
  const open = document.querySelector('[data-menu-open]');
  const close = document.querySelector('[data-menu-close]');
  if (menu && open && close) {
    open.addEventListener('click', () => menu.showModal());
    close.addEventListener('click', () => menu.close());
    menu.addEventListener('click', (event) => { if (event.target === menu) menu.close(); });
    menu.addEventListener('close', () => open.focus());
  }

  document.querySelectorAll('.saga-form').forEach((form) => {
    form.addEventListener('invalid', (event) => {
      const details = event.target.closest('details');
      if (details) details.open = true;
    }, true);
  });
  document.querySelector('[data-form-success]')?.focus();

  const sampleForm = document.querySelector('#SagaSampleForm');
  if (sampleForm) {
    const requested = new URL(window.location.href).searchParams.get('tea');
    const primary = sampleForm.querySelector('[data-sample-primary]');
    if (!sampleForm.querySelector('[data-form-error]') && requested && primary && [...primary.options].some((option) => option.value === requested)) primary.value = requested;
    const additional = [...sampleForm.querySelectorAll('[data-sample-choice]')];
    const syncAdditional = () => {
      const unsure = primary?.value === 'not-sure';
      additional.forEach((choice) => {
        const duplicate = choice.dataset.sampleHandle === primary?.value;
        if (unsure || duplicate) choice.checked = false;
      });
      const additionalCount = additional.filter((choice) => choice.checked).length;
      const additionalLimitReached = additionalCount >= 3;
      const additionalOverLimit = additionalCount > 3;
      additional.forEach((choice) => {
        const duplicate = choice.dataset.sampleHandle === primary?.value;
        choice.disabled = Boolean(unsure || duplicate || (additionalLimitReached && !choice.checked));
        choice.setCustomValidity?.(additionalOverLimit ? 'Choose no more than three additional teas.' : '');
      });
    };
    primary?.addEventListener('change', syncAdditional);
    additional.forEach((choice) => choice.addEventListener('change', syncAdditional));
    syncAdditional();
  }

  const samplePicker = document.querySelector('[data-sample-picker]');
  if (samplePicker) {
    const requested = new URL(window.location.href).searchParams.get('tea');
    const row = requested && [...samplePicker.querySelectorAll('[data-sample-row]')].find((item) => item.dataset.sampleHandle === requested);
    if (row) {
      row.classList.add('is-requested');
      row.querySelector('button, a')?.focus({ preventScroll: true });
      row.scrollIntoView({ block: 'center' });
    }
  }

  const contactForm = document.querySelector('#SagaInquiryForm');
  if (contactForm) {
    const params = new URL(window.location.href).searchParams;
    const requested = params.get('tea');
    const tea = contactForm.querySelector('[data-contact-tea]');
    const purpose = contactForm.querySelector('[data-contact-purpose]');
    if (!contactForm.querySelector('[data-form-error]') && requested && tea && [...tea.options].some((option) => option.value === requested)) {
      tea.value = requested;
      if (purpose && params.get('purpose') === 'Product availability') purpose.value = 'Product availability';
    }
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const choices = [...gallery.querySelectorAll('.saga-product-gallery__choice')];
    const panels = gallery.querySelector('[data-gallery-panels]');
    if (choices.length < 2 || !panels) return;
    gallery.setAttribute('data-gallery-enhanced', '');
    const showChoice = () => {
      const index = choices.findIndex((choice) => choice.checked);
      panels.scrollTo({ left: Math.max(index, 0) * panels.clientWidth, behavior: 'instant' });
    };
    choices.forEach((choice) => choice.addEventListener('change', showChoice));
    panels.addEventListener('scroll', () => {
      if (!panels.clientWidth) return;
      const index = Math.max(0, Math.min(choices.length - 1, Math.round(panels.scrollLeft / panels.clientWidth)));
      choices[index].checked = true;
    }, { passive: true });
    window.addEventListener('resize', showChoice);
    showChoice();
  });

  const variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    const quantity = document.querySelector('[data-quantity]');
    const quantityTotal = document.querySelector('[data-quantity-total]');
    const submit = document.querySelector('[data-add-to-cart]');
    const variantContext = variantSelect.closest('[data-variant-context]');
    const unavailable = document.querySelector('[data-unavailable-variant]');
    const requestedVariant = new URL(window.location.href).searchParams.get('variant');
    const requestedVariantUnavailable = requestedVariant && ![...variantSelect.options].some((option) => option.value === requestedVariant);
    if (requestedVariantUnavailable) {
      variantContext.querySelectorAll('button,input,select,textarea').forEach((control) => { control.disabled = true; });
      variantContext.hidden = true;
      if (unavailable) unavailable.hidden = false;
    }
    const updateQuantityTotal = () => {
      if (!quantity || !quantityTotal) return;
      if (!quantity.dataset.packKilograms) {
        quantityTotal.hidden = true;
        quantityTotal.textContent = '';
        return;
      }
      const summary = globalThis.SagaOrderQuantity.summarizeKilograms({
        quantity: quantity.value,
        packKilograms: quantity.dataset.packKilograms,
        min: quantity.min,
        step: quantity.step,
        max: quantity.max
      });
      quantityTotal.hidden = false;
      quantityTotal.textContent = summary.text;
      quantityTotal.dataset.state = summary.valid ? 'valid' : 'invalid';
    };
    const updateVariant = () => {
      const option = variantSelect.selectedOptions[0];
      document.querySelectorAll('[data-variant-panel]').forEach((panel) => { panel.hidden = panel.dataset.variantPanel !== option.value; });
      const available = option.dataset.available === 'true';
      if (quantity) {
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.increment || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        if (option.dataset.packKilograms) quantity.dataset.packKilograms = option.dataset.packKilograms; else delete quantity.dataset.packKilograms;
        if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
        updateQuantityTotal();
      }
      if (submit) { submit.disabled = !available; submit.textContent = available ? 'Add to cart' : 'Sold out'; }
    };
    if (!requestedVariantUnavailable) {
      variantSelect.addEventListener('change', () => {
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', variantSelect.value);
        window.history.replaceState({}, '', nextUrl);
        updateVariant();
      });
      quantity?.addEventListener('input', updateQuantityTotal);
      quantity?.addEventListener('change', updateQuantityTotal);
      updateVariant();
    }
  }

  const guideChecks = [...document.querySelectorAll('[data-guide-check]')];
  const guideRows = [...document.querySelectorAll('[data-guide-row]')];
  const guideCompareCells = [...document.querySelectorAll('[data-guide-compare-cell]')];
  const guideControls = document.querySelector('[data-guide-controls]');
  const guideStatus = document.querySelector('[data-guide-status]');
  const guideClear = document.querySelector('[data-guide-clear]');
  const guideUseNav = document.querySelector('[data-guide-use-nav]');
  const useLinks = [...document.querySelectorAll('[data-guide-use]')];
  const useStatus = document.querySelector('[data-guide-use-status]');
  const useClear = document.querySelector('[data-guide-use-clear]');
  const useNames = { lattes: 'lattes', culinary: 'culinary & desserts', rtd: 'ready-to-drink', brewed: 'brewed tea' };
  const supportedUses = {
    '4-ureshino-green-tea-powder': ['culinary', 'rtd'],
    'genmaicha-powder': ['lattes', 'culinary', 'rtd'],
    'ceremonial-grade-ureshino-green-tea': ['lattes', 'culinary', 'rtd'],
    'super-premium-ureshino-green-tea-powder': ['lattes', 'culinary', 'rtd'],
    'artisanal-roasted-hojicha-saga-heritage-wholesale-grade': ['lattes', 'culinary', 'rtd'],
    'stc-organic-hojicha': ['lattes', 'culinary', 'rtd'],
    'single-cultivar-saemidori-matcha': ['lattes', 'culinary'],
    'shizuoka-matcha-blend': ['lattes', 'culinary'],
    'super-premium-ureshino-green-tea-powder-copy': ['brewed'],
    'premium-ureshino-green-tea-leaf': ['brewed'],
    'premium-saga-kamairicha-pan-fired-green-tea': ['brewed'],
    'hojicha-powder': ['brewed'],
    'kojis-aracha-asatsuyu': ['brewed'],
    'kojis-yabukita': ['brewed'],
    'kojis-kamairicha': ['brewed'],
    'genmaicha-leaf': ['brewed'],
    'wakocha': ['brewed'],
    'zero-tea': ['brewed']
  };
  let activeUse = null;
  const useFromUrl = () => {
    const use = new URL(window.location.href).searchParams.get('use');
    return Object.hasOwn(useNames, use) ? use : null;
  };
  const rowHandle = (row) => {
    if (row.dataset?.guideHandle) return row.dataset.guideHandle;
    const href = row.querySelector('th a')?.getAttribute('href');
    if (!href) return null;
    let path;
    try { path = new URL(href, window.location.href).pathname.replace(/\/+$/, ''); }
    catch { return null; }
    return path.split('/').pop()?.replace(/^tea-/, '');
  };
  const updateUse = () => {
    let matched = 0;
    const matchingRows = [];
    guideRows.forEach((row) => {
      const isMatch = activeUse && supportedUses[rowHandle(row)]?.includes(activeUse);
      if (isMatch) { matched += 1; matchingRows.push(row); }
      row.classList.toggle('is-use-match', Boolean(isMatch));
      row.classList.toggle('is-use-other', Boolean(activeUse && !isMatch && !row.querySelector('[data-guide-check]')?.checked));
    });
    const tableBody = guideRows[0]?.parentElement;
    const selectedRows = guideRows.filter((row) => row.querySelector('[data-guide-check]')?.checked);
    const selectedSet = new Set(selectedRows);
    const matchingSet = new Set(matchingRows);
    const orderedRows = [
      ...selectedRows,
      ...matchingRows.filter((row) => !selectedSet.has(row)),
      ...guideRows.filter((row) => !selectedSet.has(row) && !matchingSet.has(row))
    ];
    if (tableBody && orderedRows.some((row, index) => tableBody.children[index] !== row)) {
      const focusedCheck = guideChecks.includes(document.activeElement) ? document.activeElement : null;
      orderedRows.forEach((row) => tableBody.appendChild(row));
      focusedCheck?.focus();
      // A pending smooth focus scroll still targets the row's old position.
      focusedCheck?.scrollIntoView({ block: 'center', behavior: 'instant' });
    }
    useLinks.forEach((link) => {
      const selected = link.dataset.guideUse === activeUse;
      link.classList.toggle('is-active', selected);
      if (selected) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
    });
    if (useClear) useClear.hidden = !activeUse;
    if (useStatus) useStatus.textContent = activeUse
      ? `${matched} teas highlighted for ${useNames[activeUse]}. Other teas may also suit your recipe; browse every tea below.`
      : 'All teas are shown below. Select a use to highlight a starting point.';
  };
  const updateGuide = () => {
    const selected = guideChecks.filter((item) => item.checked);
    guideRows.forEach((row) => {
      row.classList.toggle('is-muted', selected.length > 0 && !row.querySelector('[data-guide-check]')?.checked);
    });
    if (guideClear) guideClear.hidden = selected.length === 0;
    if (guideStatus) guideStatus.textContent = selected.length
      ? `${selected.length} tea${selected.length === 1 ? '' : 's'} selected together at the top. Other teas remain listed.`
      : 'Select up to three teas to compare together at the top.';
    updateUse();
  };
  guideChecks.forEach((check) => check.addEventListener('change', () => {
    if (guideChecks.filter((item) => item.checked).length > 3) {
      check.checked = false;
      if (guideStatus) guideStatus.textContent = 'Three teas are already selected. Uncheck one or clear your selection to choose another.';
      return;
    }
    updateGuide();
  }));
  guideClear?.addEventListener('click', () => {
    guideChecks.forEach((check) => { check.checked = false; });
    updateGuide();
    (guideRows[0]?.parentElement?.children[0]?.querySelector('[data-guide-check]') || guideChecks[0])?.focus();
  });
  if (guideChecks.length) {
    guideChecks.forEach((check) => { check.disabled = false; });
    guideCompareCells.forEach((cell) => { cell.hidden = false; });
    if (guideControls) guideControls.hidden = false;
    guideChecks.filter((check) => check.checked).slice(3).forEach((check) => { check.checked = false; });
    updateGuide();
  }
  if (guideRows.length && useLinks.length) {
    if (guideUseNav) guideUseNav.hidden = false;
    activeUse = useFromUrl();
    updateGuide();
    useLinks.forEach((link) => link.addEventListener('click', (event) => {
      if (event.defaultPrevented || (event.button !== undefined && event.button !== 0) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (activeUse === link.dataset.guideUse) return;
      activeUse = link.dataset.guideUse;
      window.history.pushState({}, '', link.href);
      updateGuide();
    }));
    useClear?.addEventListener('click', () => {
      activeUse = null;
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.delete('use');
      window.history.pushState({}, '', nextUrl);
      updateGuide();
      useLinks[0]?.focus();
    });
    window.addEventListener('popstate', () => { activeUse = useFromUrl(); updateGuide(); });
  }

  const recipeForm = document.querySelector('[data-recipe-form]');
  if (recipeForm && typeof window.SagaRecipeCalculator?.calculateRecipe === 'function') {
    const recipePanel = document.querySelector('[data-recipe-calculator]');
    const recipeFallback = document.querySelector('[data-recipe-unavailable]');
    const fields = ['teaUsdKg', 'doseGrams', 'milkUsdLiter', 'milkMl', 'otherIngredientsUsd', 'packagingUsd', 'wastePercent', 'sellPriceUsd'];
    const error = document.querySelector('[data-calc-error]');
    const result = document.querySelector('[data-calc-result]');
    const initialResult = '<p class="eyebrow">Per serving</p><h2>Start with your inputs.</h2><p>Your result appears here once every cost is entered.</p>';
    const money = (value) => value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    const reset = () => { error.textContent = ''; result.innerHTML = initialResult; };
    recipeForm.addEventListener('input', reset);
    recipeForm.addEventListener('submit', (event) => {
      event.preventDefault();
      error.textContent = '';
      try {
        const values = Object.fromEntries(fields.map((key) => [key, recipeForm.elements[key].value]));
        const { tea, milk, ingredients, cost, contribution, contributionPercent } = window.SagaRecipeCalculator.calculateRecipe(values);
        result.innerHTML = `<p class="eyebrow">Recipe cost / serving</p><p class="calculator__total">${money(cost)}</p><dl><div><dt>Tea before waste</dt><dd>${money(tea)}</dd></div><div><dt>Milk before waste</dt><dd>${money(milk)}</dd></div><div><dt>Ingredients including waste</dt><dd>${money(ingredients)}</dd></div><div><dt>Total recipe cost</dt><dd>${money(cost)}</dd></div><div><dt>Recipe contribution</dt><dd>${money(contribution)}</dd></div><div><dt>Contribution / selling price</dt><dd>${contributionPercent.toFixed(1)}%</dd></div></dl><p>Based only on your inputs. Before labor, fees and overhead.</p>`;
      } catch (problem) {
        result.innerHTML = initialResult;
        error.textContent = problem.message;
        error.focus();
      }
    });
    if (recipePanel) recipePanel.hidden = false;
    if (recipeFallback) recipeFallback.hidden = true;
  }
})();
